import styled from 'styled-components';
import ds from 'designsystem';

const Background = styled.div`
  position: relative;
  background-color: ${ds.brand('background')};
  `;

export default Background;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/Background.jsx